'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _plugin = require('@swup/plugin');

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HtmlLangPlugin = function (_Plugin) {
  _inherits(HtmlLangPlugin, _Plugin);

  function HtmlLangPlugin(options) {
    _classCallCheck(this, HtmlLangPlugin);

    var _this = _possibleConstructorReturn(this, (HtmlLangPlugin.__proto__ || Object.getPrototypeOf(HtmlLangPlugin)).call(this));

    _this.name = 'HtmlLangPlugin';


    var defaultOptions = {};

    _this.options = _extends({}, defaultOptions, options);
    _this.parser = new DOMParser();
    return _this;
  }

  _createClass(HtmlLangPlugin, [{
    key: 'mount',
    value: function mount() {
      var _this2 = this;

      this.swup.on('contentReplaced', function () {
        var _swup$cache$getCurren = _this2.swup.cache.getCurrentPage(),
            originalContent = _swup$cache$getCurren.originalContent;

        var page = _this2.parser.parseFromString(originalContent, 'text/html');
        var lang = page.documentElement.getAttribute('lang');

        if (document.documentElement.getAttribute('lang') !== lang) {
          document.documentElement.setAttribute('lang', lang);
        }
      });
    }
  }, {
    key: 'unmount',
    value: function unmount() {}
  }]);

  return HtmlLangPlugin;
}(_plugin2.default);

exports.default = HtmlLangPlugin;